<template>
  <div class="table-wrapper">
    <div class="table-header">
      <span
        v-for="(item, index) in cols"
        :style="getTableColumnStyle(item)"
        class="qrw-label-sm bold"
        :key="index"
        >{{ item.title }}</span
      >
      <span
        class="actions-column qrw-label-sm"
        v-if="hasActions"
      ></span>
    </div>

    <div class="table-body">
      <div
        v-for="(row, rowIndex) in rows"
        :key="rowIndex"
        class="table-list"
      >
        <span
          v-for="(col, colIndex) in cols"
          :style="getTableColumnStyle(col)"
          class="table-list-item qrw-label-sm"
          :key="colIndex"
          @click="$emit('rowClick', row)"
        >
          <slot
            :index="rowIndex"
            :rowItem="row"
            :name="`col-${col.key || colIndex}`"
          >
            {{ getCellDefaultContent(row, col, rowIndex, colIndex) }}
          </slot>
        </span>
        <span
          class="table-list-item qrw-label-sm actions-column"
          v-if="hasActions"
        >
          <slot name="actions" :rowItem="row" :index="rowIndex" />
        </span>
      </div>
    </div>
  </div>
</template>


<script>
import moment from "moment";

export default {
  props: {
    cols: Array,
    rows: Array,
    hasActions: Boolean,
  },
  methods: {
    getTableColumnStyle(column) {
      return {
        width: column.width ? `${column.width}px` : "100%",
        "min-width": column.width ? `${column.width}px` : "auto",
      };
    },
    getCellDefaultContent(row, col, rowIndex, colIndex) {
      let value = row[colIndex] || null;

      if (col.index) value = rowIndex + 1;

      if (col.key) value = row[col.key] || col.default || "";

      if (col.date) {
        value = moment(value).format("DD.MM.YYYY");
      }

      if (col.time) {
        value = moment(value).format("HH:mm");
      }

      if (col.datetime) {
        value = moment(value).format("DD.MM.YYYY HH:mm");
      }

      if (col.currency) {
        const currency = this.$store.state.currency;
        value = `${value} ${currency[col.currency]}`;
      }

      if (col.unit) {
        value = `${value} ${col.unit}`;
      }

      if (col.renderer) {
        value = col.renderer(row);
      }

      return value;
    },
  },
};
</script>

<style>
.table-wrapper {
  width: 100%;
  height: calc(100vh - 60px);
}
.table-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  background: var(--v1-grey-8-color);
  align-items: center;
}

.table-header span {
  padding: 8px 16px;
  text-align: center;
  color: var(--white-color);
}

.table-list {
  background: var(--v1-grey-2-color);
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.table-list:last-child {
  margin-bottom: 15px;
}

.table-list-item {
  padding: 8px 16px;
  text-align: center;
  color: var(--black-color);
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.table-body {
  overflow: auto;
  display: flex;
  flex-flow: column;
  row-gap: 2px;
  height: 100%;
}

.table-list:hover {
  background: var(--green-5-color);
  cursor: pointer;
}

.table-list:hover span {
  color: var(--v1-grey-3-color);
}

.actions-column {
  min-width: 60px;
  width: 60px;
  margin-left: 40px;
  visibility: hidden;
  display: flex;
}

.table-list:hover .actions-column {
  visibility: visible;
  min-height: 1px;
}

.actions-column span {
  padding: 0;
}
</style>